interface Filters {
  nextOccurrence?: (string | undefined)[]
  reviewer?: number | 'me'
  requester?: number | 'me'
  article?: string
}

export const scheduledReviewsKeys = {
  prefix: 'scheduledReviews',
  list: (workspaceId: number, filters?: Filters) => {
    const key: [
      string,
      number,
      string,
      (string | undefined)[]?,
      ['reviewer', number | 'me']?,
      ['requester', number | 'me']?,
      string?,
    ] = [scheduledReviewsKeys.prefix, workspaceId, 'list']
    if (filters?.nextOccurrence) {
      key.push(filters.nextOccurrence)
    }
    if (filters?.reviewer) {
      key.push(['reviewer', filters.reviewer])
    }
    if (filters?.requester) {
      key.push(['requester', filters.requester])
    }
    if (filters?.article) {
      key.push(filters.article)
    }
    return key
  },
  detail: (id: number) => [scheduledReviewsKeys.prefix, 'detail', id],
  delete: (id: number) => [...scheduledReviewsKeys.detail(id), 'delete'],
}
